/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserStatisticsInfoVo } from './UserStatisticsInfoVo';
import {
    UserStatisticsInfoVoFromJSON,
    UserStatisticsInfoVoFromJSONTyped,
    UserStatisticsInfoVoToJSON,
    UserStatisticsInfoVoToJSONTyped,
} from './UserStatisticsInfoVo';

/**
 * 
 * @export
 * @interface ResponseUserStatisticsInfoVo
 */
export interface ResponseUserStatisticsInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUserStatisticsInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUserStatisticsInfoVo
     */
    message?: string;
    /**
     * 
     * @type {UserStatisticsInfoVo}
     * @memberof ResponseUserStatisticsInfoVo
     */
    data?: UserStatisticsInfoVo;
}

/**
 * Check if a given object implements the ResponseUserStatisticsInfoVo interface.
 */
export function instanceOfResponseUserStatisticsInfoVo(value: object): value is ResponseUserStatisticsInfoVo {
    return true;
}

export function ResponseUserStatisticsInfoVoFromJSON(json: any): ResponseUserStatisticsInfoVo {
    return ResponseUserStatisticsInfoVoFromJSONTyped(json, false);
}

export function ResponseUserStatisticsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserStatisticsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UserStatisticsInfoVoFromJSON(json['data']),
    };
}

export function ResponseUserStatisticsInfoVoToJSON(json: any): ResponseUserStatisticsInfoVo {
    return ResponseUserStatisticsInfoVoToJSONTyped(json, false);
}

export function ResponseUserStatisticsInfoVoToJSONTyped(value?: ResponseUserStatisticsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UserStatisticsInfoVoToJSON(value['data']),
    };
}

